<template>
    <div class="container-add">
        <div class="button-exit">
            <ui-button design="sm line" @click="returnAddIntegration">
                <em class="far fa-chevron-left" />
            </ui-button>
        </div>

        <div class="data-integration">
            <span class="data-integration-title">Outras configurações</span>
            <span class="data-integration-subtitle">
                Personalize suas integrações preenchendo os campos abaixo.
            </span>
        </div>

        <div class="hr" />
        <div class="body-integration">
            <div v-if="loading.loaderIndicator" class="body-integration-loading">
                <ui-load-indicator v-if="loading.loaderIndicator" bg-color="#e7e9f4" color="#69D296" :h="40" :stroke="8" />
            </div>

            <div v-if="form.data.type === 'uau' || form.data.type === 'sienge'">
                <div class="body-integration-units">
                    <div class="body-integration-units-value">
                        <ui-select-v2
                            v-model="form.data.show_value"
                            :data="showValueOptions"
                            :required="form.fields.show_value.required"
                            :disabled="form.fields.show_value.disabled"
                            :search="false"
                            :show-footer="false"
                            label="Exibir valor das unidades:"
                            return-value="value"
                            design="br-all"
                            size="md" />
                    </div>

                    <div class="body-integration-units-status">
                        <ui-select-v2
                            v-model="form.data.hide_unusual_status"
                            :data="unusualStatusOptions"
                            :required="form.fields.hide_unusual_status.required"
                            :disabled="form.fields.hide_unusual_status.disabled"
                            :search="false"
                            :show-footer="false"
                            label="Unidades com status incomum:"
                            return-value="value"
                            design="br-all"
                            size="md" />
                    </div>
                </div>

                <div class="body-integration-color-units">
                    <div class="body-integration-color-units-available">
                        <ui-color-picker
                            v-model="form.data.color_available"
                            :required="form.fields.color_available.required"
                            :disabled="form.fields.color_available.disabled"
                            label="Cor para unidades disponíveis:"
                        />
                    </div>

                    <div class="body-integration-color-units-unavailable">
                        <ui-color-picker
                            v-model="form.data.color_unavailable"
                            :required="form.fields.color_unavailable.required"
                            :disabled="form.fields.color_unavailable.disabled"
                            label="Cor para unidades indisponíveis:"
                        />
                    </div>
                </div>
            </div>

            <div v-if="form.data.type === 'informakon'">
                <div class="body-integration-units-informakon">
                    <div
                        v-for="field in setData"
                        :key="field.id"
                        class="units-informakon"
                        :style="{
                            'display': field.slug != 'especieContrato-proposta'
                                && field.slug != 'aplicacaoReajuste-proposta'
                                && field.slug != 'taxaJurosMora-proposta'
                                && field.slug != 'taxaMultaMora-proposta'
                                ? 'none' : 'block'
                        }"
                    >
                        <div v-if="field.type === 'select'" class="field-container-select">
                            <ui-select-v2
                                v-if="field.slug === 'especieContrato-proposta'"
                                v-model="form.data.data.especieContrato"
                                design="mgb-15 br-all"
                                :search="false"
                                :label="field.name"
                                :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                                :placeholder="field.placeholder ? field.placeholder : 'Selecione'"
                                :data="field.options.options"
                            />
                            <ui-select-v2
                                v-if="field.slug === 'aplicacaoReajuste-proposta'"
                                v-model="form.data.data.aplicacaoReajuste"
                                design="mgb-15 br-all"
                                :search="false"
                                :label="field.name"
                                :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                                :placeholder="field.placeholder ? field.placeholder : 'Selecione'"
                                :data="field.options.options"
                            />
                        </div>
                        <div v-if="['text', 'email', 'tel'].includes(field.type)" class="field-container-input">
                            <ui-input
                                v-if="field.slug === 'taxaJurosMora-proposta'"
                                v-model="form.data.data.taxaJurosMora"
                                :label="field.name"
                                :type="field.type"
                                :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                                :placeholder="field.placeholder"
                                group="%"
                                percent
                            />
                            <ui-input
                                v-if="field.slug === 'taxaMultaMora-proposta'"
                                v-model="form.data.data.taxaMultaMora"
                                :label="field.name"
                                :type="field.type"
                                :required="typeof field.required === 'boolean' ? field.required : field.required == 0 ? false : true"
                                :placeholder="field.placeholder"
                                group="%"
                                percent
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="form.data.type === 'uau'">
                <!-- <div class="body-integration-calculation">
					<div class="body-integration-calculation-base-x">
						<ui-input v-model="form.data.factor_x"
							:required="form.fields.factor_x.required"
							:disabled="form.fields.factor_x.disabled"
							:invertgroup="true"
							label="Base de Cálculo(X):"
							type="text"
						/>
					</div>

					<div class="body-integration-calculation-base-y">
						<ui-input v-model="form.data.factor_y"
							:required="form.fields.factor_y.required"
							:disabled="form.fields.factor_y.disabled"
							:invertgroup="true"
							label="Base de Cálculo(Y):"
							type="text"
						/>
					</div>
				</div> -->

                <div class="body-integration-proposal-settings-title">
                    <span class="settings-add-proposal">Configurações Adicionais da Proposta</span>
                </div>

                <div class="body-integration-proposal-settings">
                    <div class="body-integration-proposal-settings-client-origin">
                        <ui-input
                            v-model="form.data.data.uauProposalTime"
                            :required="form.fields.uauProposalTime.required"
                            :disabled="form.fields.uauProposalTime.disabled"
                            :invertgroup="true"
                            label="Validade da Proposta (minutos):"
                            type="text"
                        />
                    </div>

                    <div class="body-integration-proposal-settings-client-origin">
                        <ui-input
                            v-model="form.data.data.uauClientOriginCode"
                            :required="form.fields.uauClientOriginCode.required"
                            :disabled="form.fields.uauClientOriginCode.disabled"
                            :invertgroup="true"
                            label="Código de Origem do Cliente:"
                            type="text"
                        />
                    </div>
                </div>

                <div class="body-integration-proposal-settings-percent">
                    <ui-select-v2
                        v-model="form.data.data.uauPercentContract"
                        :data="contractPercentageOptions"
                        :required="form.fields.uauPercentContract.required"
                        :disabled="form.fields.uauPercentContract.disabled"
                        :search="false"
                        :show-footer="false"
                        label="Porcentagem no Contrato:"
                        return-value="value"
                        design="br-all"
                        size="md" />
                </div>

                <div class="body-integration-proposal-settings-future-value">
                    <ui-switch
                        v-model="form.data.data.uauFutureValue"
                        :checked="form.data.data.uauFutureValue"
                        label="Enviar Valor Futuro"
                        design="xs primary"
                    />
                    <ui-tooltip-icon text="As condições de pagamento serão enviadas ao ERP UAU com os valores futuros já calculados, permitindo um novo cálculo sobre esses valores." size="sm"/>
                </div>
            </div>

            <div v-if="form.data.type === 'sienge'" class="body-integration-plan-id">
                <div class="body-integration-plan">
                    <span>Plano financeiro:</span>
                    <ui-input type="text" placeholder="Digite..." />
                </div>
                <div class="body-integration-id">
                    <span>Portador e ID:</span>
                    <ui-input type="text" placeholder="Carteira - 20" />
                </div>
            </div>
        </div>

        <div class="footer-container">
            <div class="footer-container-oval-first" />
            <div class="footer-container-oval-second" />
            <ui-button
                :disabled="!canSubmit"
                :loading="!id ? loading.submit : null"
                design="success lg mw-150"
                @click="submitHandler"
            >
                Salvar Integração
            </ui-button>
        </div>

        <ui-modal-info
            :action="submit"
            name="update-integration-erp-confirm"
            title="Empreendimentos já cadastrados não serão impactados. Deseja continuar?"
            icon="fal fa-info-circle"
            color-circle="#3CA2FF"
            btn-text="Confirmar"
            btn-type="success"
            icon-circle
            footer
            can-submit
            :loading="loading.submit"
        />

        <modal-add-success />
    </div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiColorPicker, uiSelectV2, uiSwitch } from '@/components/ui/form'
	import { uiLoadIndicator, uiTooltipIcon } from '@/components/ui'
	import { uiModalInfo } from '@/components/ui/modal'

	import modalAddSuccess from '../modal-add-success'

	import { erp, fieldGroupHasField } from '@/services/axios'

	import { mapActions } from 'vuex'

	const lodash = require("lodash")

	const defaultLoading = () => ({
		submit: false,
		loaderIndicator: false
	})

	export default {
		name: 'other-settings',

		components: {
			uiButton,
			uiInput,
			uiSelectV2,
			uiColorPicker,
			modalAddSuccess,
			uiLoadIndicator,
			uiModalInfo,
			uiSwitch,
			uiTooltipIcon
		},

		props: {
			id: {
				type: [String,Number],
				required: false,
				default: 0
			},
			form: {
				type: Object,
				required: true
			},
			index: {
				Type: String,
			},
		},

		data() {
			return {
				loading: { ...defaultLoading() },
				setData: null,
				required: null,
				showValueOptions: [
					{
						label: 'Ocultar valor',
						value: 'hidden'
					},
					{
						label: 'Em unidades disponíveis',
						value: 'available'
					},
					{
						label: 'Em todas as unidades',
						value: 'all'
					}
				],
				unusualStatusOptions: [
					{
						label: 'Não mostrar unidades',
						value: 'hidden'
					},
					{
						label: 'Apresentar como vendida',
						value: ' '
					}
				],
				contractPercentageOptions: [
					{
						label: 'Dividido entre Cliente Titular e Não Titular',
						value: 'half'
					},
					{
						label: 'Cliente Titular',
						value: 'holderOnly'
					}
				]
			}
		},

		computed: {
			/**
			 * Computed property que valida o formulário e define se este pode ser
			 * submetido ou não
			 */
			canSubmit() {
				return this.validateForm().valid
			}
		},

		mounted() {
			const isUAU = !!(this.form.data.type === 'uau')
			this.form.fields.factor_x.disabled = !isUAU
			this.form.fields.factor_y.disabled = !isUAU
			this.form.fields.uauProposalTime.disabled = !isUAU
			this.form.fields.uauClientOriginCode.disabled = !isUAU
			this.form.fields.uauPercentContract.disabled = !isUAU
			this.getFieldsInformakon()
		},

		methods: {
			...mapActions('ERP', [
				'selectIntegration'
			]),
			/**
			 * Emite um evento para retornar ao passo anterior do cadastro da Integração
			 */
			returnAddIntegration() {
				this.$emit('back')
			},
			/**
			 * Valida a propriedade required dos campos do formulário
			 */
			validateRequired(field, dataField = '') {
				if (!this.form.fields.hasOwnProperty(field)) {
					throw new Error(`Falha ao validar o campo ${field}. Este campo não existe!`)
				}
				dataField = dataField || field
				if(this.required) {
					const especieContratoField = this.required.find(field => field.slug === 'especieContrato-proposta');
				if(especieContratoField && especieContratoField.required) this.form.fields.especieContrato.required = especieContratoField.required
				const taxaJurosMoraField = this.required.find(field => field.slug === 'taxaJurosMora-proposta');
				if(taxaJurosMoraField && taxaJurosMoraField.required)this.form.fields.taxaJurosMora.required = taxaJurosMoraField.required
				const aplicacaoReajusteField = this.required.find(field => field.slug === 'aplicacaoReajuste-proposta');
				if(aplicacaoReajusteField && aplicacaoReajusteField.required)this.form.fields.aplicacaoReajuste.required = aplicacaoReajusteField.required
				const taxaMultaMoraField = this.required.find(field => field.slug === 'taxaMultaMora-proposta');
				if(taxaMultaMoraField && taxaMultaMoraField.required)this.form.fields.taxaMultaMora.required = taxaMultaMoraField.required
				}
				const required = this.form.fields[field].required
				const validation = lodash.get(this.form.data, dataField) ||
					parseInt(lodash.get(this.form.data, dataField)) === 0

				return (required && validation) || !required
			},
			/**
			 * Valida os campos do formulário de acordo com diferentes conjuntos de regras
			 */
			validateForm() {
				let valid = true
				let message = '<ul>'
				try {
					if ((this.form.data.type === 'uau' || this.form.data.type === 'sienge') && !this.validateRequired('show_value')) {
						valid = false
						message += '<li>É necessário selecionar se será exibido os valores das unidades.</li>'
					}

					if ((this.form.data.type === 'uau' || this.form.data.type === 'sienge') && !this.validateRequired('color_available')) {
						valid = false
						message += '<li>É necessário selecionar a cor para as unidades disponíveis.</li>'
					}

					if ((this.form.data.type === 'uau' || this.form.data.type === 'sienge') && !this.validateRequired('color_unavailable')) {
						valid = false
						message += '<li>É necessário selecionar a cor para as unidades indisponíveis.</li>'
					}

					if ((this.form.data.type === 'uau' || this.form.data.type === 'sienge') && !this.validateRequired('hide_unusual_status')) {
						valid = false
						message += '<li>É necessário configurar as unidades com status incomuns.</li>'
					}

					if ((this.form.data.type === 'uau' || this.form.data.type === 'sienge') && !this.validateRequired('factor_x')) {
						valid = false
						message += '<li>É necessário informar a base de cálculo (x).</li>'
					}

					if ((this.form.data.type === 'uau' || this.form.data.type === 'sienge') && !this.validateRequired('factor_y')) {
						valid = false
						message += '<li>É necessário informar a base de cálculo (y).</li>'
					}

					if (this.form.data.type === 'uau' && !this.validateRequired('uauProposalTime', 'data.uauProposalTime')) {
						valid = false
						message += '<li>É necessário informar o tempo de validade da proposta.</li>'
					}

					if (this.form.data.type === 'uau' && !this.validateRequired('uauClientOriginCode', 'data.uauClientOriginCode')) {
						valid = false
						message += '<li>É necessário informar o código de origem do cliente.</li>'
					}

					if (this.form.data.type === 'uau' && !this.validateRequired('uauPercentContract', 'data.uauPercentContract')) {
						valid = false
						message += '<li>É necessário informar a porcentagem no contrato.</li>'
					}
					if (this.form.data.type === 'informakon' && !this.validateRequired('especieContrato', 'data.especieContrato')) {
						valid = false
						message += '<li>É necessário informar a Espécie Contrato no contrato.</li>'
					}
					if (this.form.data.type === 'informakon' && !this.validateRequired('taxaJurosMora', 'data.taxaJurosMora')) {
						valid = false
						message += '<li>É necessário informar a taxa de juros mora no contrato.</li>'
					}
					if (this.form.data.type === 'informakon' && !this.validateRequired('aplicacaoReajuste', 'data.aplicacaoReajuste')) {
						valid = false
						message += '<li>É necessário informar a Aplicação de Reajuste no contrato.</li>'
					}
					if (this.form.data.type === 'informakon' && !this.validateRequired('taxaMultaMora', 'data.taxaMultaMora')) {
						valid = false
						message += '<li>É necessário informar a taxa de multa mora no contrato.</li>'
					}


				} catch (e) {
					this.$toastr.e(e)
					valid = false
				}
				message += '</ul>'

				return { valid, message }
			},
			submitHandler() {
				if (!this.id) return this.submit()

				//Caso tenha id, ou seja a integração já foi cadastrada, chama o modal de confirmação de alteração
				this.$root.$emit('modal-open-update-integration-erp-confirm')
			},
			/**
			 * Envia os dados para cadastrar a integração
			 */
			submit() {
				this.loading.submit = true

				if (this.id) {
					erp.updateV2('', this.id, this.form.data)
						.then(response => {
							if (response.data.msg) this.$toastr.s(response.data.msg)
							this.$router.push({ name: 'marketing.integrations.erp' })
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
							console.log(error)
						})
						.finally(() => {
							this.loading.submit = false
						})

				} else {
					erp.createV2('', this.form.data)
						.then(response => {
							if (response.data.msg) this.$toastr.s(response.data.msg)
							this.selectIntegration(response.data.data)
							this.$root.$emit('modal-open-add-success')
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
							console.log(error)
						})
						.finally(() => {
							this.loading.submit = false
						})
				}
			},
			getFieldsInformakon() {
				this.loading.loaderIndicator = true

				fieldGroupHasField.getFields()
					.then((response) => {
						this.setData = response.data
						this.required = Object.values(this.setData).map(field =>
						{return {slug: field.slug, required: typeof field.required === 'boolean' ?
						field.required : field.required == 0 ? false : true}})
						this.loading.loaderIndicator = false
					})
					.catch((error) => {
						console.error(error)
					})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>